import React from 'react'
import clsx from 'clsx'

interface CardProps {
  children: React.ReactNode
  className?: string
  borderAccent?: 'primary' | 'success' | 'warning' | 'error' | 'info'
  onClick?: () => void
  padding?: boolean
}

const accentColors: Record<string, string> = {
  primary: 'border-l-4 border-l-primary',
  success: 'border-l-4 border-l-success',
  warning: 'border-l-4 border-l-warning',
  error: 'border-l-4 border-l-error',
  info: 'border-l-4 border-l-info',
}

export default function Card({ children, className, borderAccent, onClick, padding = true }: CardProps) {
  return (
    <div
      className={clsx(
        'bg-iswara-card rounded-card shadow-card',
        borderAccent && accentColors[borderAccent],
        padding && 'p-4',
        onClick && 'cursor-pointer hover:shadow-card-hover transition-shadow duration-200',
        className
      )}
      onClick={onClick}
    >
      {children}
    </div>
  )
}
